import React from 'react';
import classes from './CollectionCover.css';
import Aux from '../../hoc/Aux';
import { NavLink } from 'react-router-dom';

const styles = {
    loadingMessage: {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
};

const collectionCover = props => {
    return (
        <Aux>
            <header className="row justify-content-center">
                <div className={'col-sm-7 col-xl-4 ' + classes.LogoContainer}>
                    <div className={classes.HeaderBackground} />
                    <img
                        className={classes.Logo}
                        src={props.logo}
                        alt={props.logoAltText}
                    />
                </div>
            </header>
            {props.leftItem && props.rightItem ? (
                <main>
                    <section className="row">
                        <div className="col-md-6 col-lg-3 order-lg-0">
                            <NavLink
                                to={props.leftItem.link}
                                className={classes.CollectionLink}
                            >
                                <img
                                    src={props.leftItem.cover}
                                    className="img-fluid"
                                    alt={props.leftItem.title}
                                />
                                <span className={classes.Title}>
                                    {props.leftItem.title}
                                </span>
                            </NavLink>
                        </div>

                        <div className="col-md-6 col-lg-3 order-lg-2">
                            <NavLink
                                to={props.rightItem.link}
                                className={classes.CollectionLink}
                            >
                                <img
                                    src={props.rightItem.cover}
                                    className="img-fluid"
                                    alt={props.rightItem.title}
                                />
                                <span className={classes.Title}>
                                    {props.rightItem.title}
                                </span>
                            </NavLink>
                        </div>

                        <div className="col-md-12 col-lg-6 order-lg-1">
                            <NavLink
                                to={props.mainItem.link}
                                className={classes.CollectionLink}
                            >
                                <video
                                    id="background-video"
                                    loop
                                    autoPlay
                                    width="100%"
                                >
                                    <source
                                        src={props.mainItem.videoURL}
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <span className={classes.Title}>
                                    {props.mainItem.title}
                                </span>
                            </NavLink>
                        </div>
                    </section>
                </main>
            ) : (
                <h2 style={styles.loadingMessage}>Cargando...</h2>
            )}
        </Aux>
    );
};

export default collectionCover;



// WEBPACK FOOTER //
// ./src/components/CollectionCover/CollectionCover.js